// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5c98674b","453":"04566a67","732":"b9bde8ca"}[chunkId] + ".chunk.js";
};